export default "__VITE_ASSET__DlRXT8fx__"